/**
 * @param {import('@/types/api').WalkinQueueEntry} entry
 */
export function queueGuestLabel(entry) {
  return entry.customer?.name ?? entry.guest_name ?? 'Walk-in guest'
}

/**
 * @param {number | null | undefined} minutes
 */
export function formatQueueEta(minutes) {
  if (!minutes || minutes <= 0) {
    return 'Ready now'
  }

  if (minutes < 60) {
    return `~${minutes} min`
  }

  const hours = Math.floor(minutes / 60)
  const mins = minutes % 60
  return mins > 0 ? `~${hours}h ${mins}m` : `~${hours}h`
}

/**
 * @param {import('@/types/api').WalkinQueueEntry[]} entries
 * @param {number} entryId
 * @param {'up' | 'down'} direction
 */
export function reorderAfterMove(entries, entryId, direction) {
  const ids = entries.map((entry) => entry.id)
  const index = ids.indexOf(entryId)

  if (index < 0) {
    return ids
  }

  const targetIndex = direction === 'up' ? index - 1 : index + 1

  if (targetIndex < 0 || targetIndex >= ids.length) {
    return ids
  }

  const next = [...ids]
  const [moved] = next.splice(index, 1)
  next.splice(targetIndex, 0, moved)

  return next
}

/**
 * @param {{ customer?: import('@/types/api').Customer | null, guestName?: string, guestPhone?: string, serviceId?: string | number, stylistId?: string | number, notes?: string }} form
 */
export function buildAddQueuePayload(form) {
  return {
    customer_id: form.customer?.id ?? null,
    guest_name: form.customer ? null : form.guestName?.trim() || null,
    guest_phone: form.customer ? null : form.guestPhone?.trim() || null,
    service_id: form.serviceId ? Number(form.serviceId) : null,
    stylist_id: form.stylistId ? Number(form.stylistId) : null,
    notes: form.notes?.trim() || null,
  }
}

/**
 * @param {{ customer?: import('@/types/api').Customer | null, guestName?: string }} form
 */
export function validateAddQueueForm(form) {
  const errors = []

  if (!form.customer?.id && !form.guestName?.trim()) {
    errors.push('Select a guest or enter a walk-in name.')
  }

  return errors
}
